import {
  Feature,
  FeatureCollection,
  GeoJsonProperties,
  Geometry,
} from 'geojson';
import { createFeatureCollection } from './createFeatureCollection';
/**
 * Combines multiple feature collections into one large feature collection
 * @param featureCollections Array of feature collections to combine
 * @returns Single feature collection containing all feature collections
 */
export const combineFeatureCollections = (
  featureCollections: FeatureCollection<Geometry, GeoJsonProperties>[]
) => {
  const features: Feature<Geometry>[] = [];

  featureCollections.forEach((featureCollection) => {
    if (featureCollection && featureCollection.features) {
      features.push(...featureCollection.features);
    }
  });

  return createFeatureCollection(features);
};
